import { useTheme } from 'styled-components';
import * as Styled from 'components/PageWrappers/AdDetails/components/Verifications/VerifiedTitle/VerifiedTitle.styled';
import { VerificationStatus } from 'components/PageWrappers/AdDetails/components/Verifications/Verifications.typed';
import type { VerifiedTitleProps } from 'components/PageWrappers/AdDetails/components/Verifications/VerifiedTitle/VerifiedTitle.typed';

import {
  getVerificationIconsAndText,
  getVerificationDetails,
} from 'components/PageWrappers/AdDetails/components/Verifications/Verifications.helpers';

import { LinkButton } from 'components/Toolkit/Button/LinkButton';

const VerifiedTitle = (props: VerifiedTitleProps) => {
  const { title, verifications, onClickTitle } = props;
  const theme = useTheme();
  const { iconStatus } = getVerificationDetails(verifications);
  const verificationData = getVerificationIconsAndText(theme, 'medium');
  const { icon } = verificationData[iconStatus];

  const showIcon = iconStatus !== VerificationStatus.NotVerified;

  return (
    <Styled.Container>
      {onClickTitle ? (
        <LinkButton onClick={onClickTitle} ofType="SECONDARY" fontSize="L18">
          {title}
        </LinkButton>
      ) : (
        <Styled.Title>{title}</Styled.Title>
      )}

      {showIcon && icon}
    </Styled.Container>
  );
};

export { VerifiedTitle };
